var React = require('react');

function GitlabInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.629 9.923L14 26 .442 15.937a1.09 1.09 0 0 1-.391-1.203l1.578-4.811zM5.752.363a.547.547 0 0 0-1.03 0l-3.093 9.56h7.216L5.752.363zm3.093 9.56L14 26l5.155-16.077H8.845zm19.104 4.81l-1.578-4.81L14 26l13.558-10.063a1.09 1.09 0 0 0 .391-1.203zM23.279.364a.547.547 0 0 0-1.031 0l-3.093 9.56h7.216L23.278.363z","fill":"#FFF","fillRule":"nonzero"}));
}

GitlabInline.defaultProps = {"aria-hidden":"true","focusable":"false","viewBox":"0 0 28 26","width":"28","height":"26"};

module.exports = GitlabInline;

GitlabInline.default = GitlabInline;
